import { useMemo } from "react";

export const useDriverCarNumbers = (races) => {
  return useMemo(() => {
    // Group races by driver and find the most recent car number
    const driverRaces = {};

    races.forEach((r) => {
      if (!r.driver_name || !r.car_number) return;

      if (!driverRaces[r.driver_name]) {
        driverRaces[r.driver_name] = r;
      } else {
        // Keep the most recent race (by date)
        const currentDate = new Date(driverRaces[r.driver_name].race_date);
        const newDate = new Date(r.race_date);
        if (newDate > currentDate) {
          driverRaces[r.driver_name] = r;
        }
      }
    });

    // Extract just the car numbers
    const map = {};
    Object.keys(driverRaces).forEach(driver => {
      map[driver] = driverRaces[driver].car_number;
    });

    return map;
  }, [races]);
};
